import React, { useContext } from "react";
import FormControl from "@mui/material/FormControl";
import Grid from "@mui/material/Grid";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import MyContext from "../../../StoreContext";
import stepOne from "./assets/stepOne.svg";
import Stack from "@mui/material/Stack";
import { trackHotjar } from "../../../helpers/hotjar";

/**
 * Componente selector que muestra los rubros en los que
 * se implementan distintos casos de uso.
 * Este es el primer paso
 */
const IndustrySelector = () => {
  const { industry, updateIndustry, updateChannel, updateMessage } =
    useContext(MyContext);

  const handleChange = (event: SelectChangeEvent) => {
    trackHotjar(`[Etapa 1] Ha seleccionado ${event.target.value}`);
    updateIndustry(event.target.value as string);
    updateChannel("");
    updateMessage("");
  };

  return (
    <Stack direction='column' spacing={2}>
      <Grid container>
        <img src={stepOne} alt='stepOne' />
      </Grid>
      <FormControl fullWidth size='small'>
        <InputLabel id='demo'>Industria</InputLabel>
        <Select
          labelId='demo'
          id='demo-simple-select'
          value={industry}
          label='Industry'
          onChange={handleChange}
          placeholder='Industria'
        >
          <MenuItem value='insurance'>Seguros</MenuItem>
          <MenuItem value='bank'>Banca</MenuItem>
          <MenuItem value='retail'>Retail</MenuItem>
        </Select>
      </FormControl>
    </Stack>
  );
};

export default IndustrySelector;
